import { useEffect, useState } from 'react';
import { durationText } from '../lib/workflow';
import type { Ticket } from '../types';

export function ServerTimer({ ticket }: { ticket: Ticket }) {
  const intervention = ticket.intervention;
  const baseSeconds = Math.max(0, Number(intervention?.durationSeconds ?? ticket.durationSeconds) || 0);
  const active = intervention?.state === 'active';
  const [anchor, setAnchor] = useState(() => ({ baseSeconds, localAt: Date.now() }));
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const localAt = Date.now();
    setAnchor({ baseSeconds, localAt });
    setNow(localAt);
  }, [baseSeconds, intervention?.revision, intervention?.state, intervention?.serverNow, ticket.runId]);

  useEffect(() => {
    if (!active) return undefined;
    const timer = window.setInterval(() => setNow(Date.now()), 1_000);
    return () => window.clearInterval(timer);
  }, [active]);

  const seconds = anchor.baseSeconds
    + (active ? Math.max(0, Math.floor((now - anchor.localAt) / 1_000)) : 0);

  return <span className="server-timer">{durationText(seconds)}</span>;
}
